import { render, staticRenderFns } from "./BulkUpdateApproveDialog.vue?vue&type=template&id=4bea3eeb&scoped=true&lang=pug&"
import script from "./BulkUpdateApproveDialog.vue?vue&type=script&lang=js&"
export * from "./BulkUpdateApproveDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bea3eeb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow,VSpacer})
